'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var initAction = { type: '@@multireducer/INIT' };

exports.default = initAction;


//////////////////
// WEBPACK FOOTER
// ./~/multireducer/lib/initAction.js
// module id = 2427
// module chunks = 66